import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'ArrowDownIcon',
  'arrow-down',
  'M905.149 598.604c21.934 24.111 21.934 63.202 0 87.313s-57.492 24.111-79.427 0.001l-313.723-344.864-313.722 344.863c-21.933 24.111-57.495 24.111-79.428 0s-21.934-63.202 0-87.313l353.436-388.52c21.934-24.11 57.496-24.11 79.43 0l353.434 388.52z',
)
